class AccountSettings.InstagramHashtagListeningRowView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/instagram_listening_hashtag_row"]
  className: $('#hashtags-list')
  tagName: 'tr'
  events:
    'change #renovation-type-values': 'onChangeRenovationType'
    'change #endpoint-type': 'onChangeListeningEndpointType'
    'change #action-selector': 'onChangeActionSelector'
    'click #action-button' : 'onClickActionButton'

  initialize: (hashtag) =>
    @hashtag = hashtag
    @enableAction = 'Enable'
    @disableAction = 'Disable'
    @removeAction = 'Remove'

  render: ->
    daysInPogress = @_setDaysForProgressBar()
    progressBarView = new AccountSettings.ProgressBarView({daysInPogress: daysInPogress, status: @hashtag.status()})
    @_formatDates()
    @$el.html(@template(hashtag: @hashtag, formatted_run_date: @formatted_run_date, formatted_expiration_date: @formatted_expiration_date))
    @$el.find('.hashtag-expiration-progress-bar').append(progressBarView.render().el)
    @_setPossibleActions(@hashtag.status())
    @_renderRenovationType()
    @_renderEndpoints()
    @_checkStatus()
    @_setStatusColor()
    @_renderGrayIfExpired()
    @

  _checkStatus: ->
    if @formatted_expiration_date
      date = @formatted_expiration_date.split('/')
      expiration_date = new Date(date[2].substring(0,4), date[1] - 1 , date[0], date[2].substring(5,7), date[2].substring(8,10))
    if expiration_date < new Date()
      @_updateByRenewal()

  _setStatusColor: =>
    @$el.find('.hashtag-status').addClass(@hashtag.status().toLowerCase())

  _renderGrayIfExpired: =>
    if @hashtag.status() == 'Expired'
      @$el.find('.hashtag-row-name').addClass('expired')
      @$el.find('.formatted-run-date').addClass('expired')
      @$el.find('.hashtag-expiration-progress-bar').addClass('expired')
      @$el.find('.formatted-expiration-date').addClass('expired')
      @$el.find('#renovation-type-values').addClass('expired')
      @$el.find('#listening-endpoint').addClass('expired')
      @$el.find('#hashtag-actions').addClass('expired')

  _updateByRenewal: ->
    if @hashtag.isAutomaticRenewal()
      hashtag_data = {
        source_id: @hashtag.sourceId(),
        hashtag_name: @hashtag.name(),
        hashtag_id: @hashtag.id
      }
      @_enableHashtagListening(hashtag_data)
    else
      @_updateToExpiredStatus()

  _formatDates: ->
    if(@hashtag.runDate())
      @formatted_run_date = new Date(Date.parse(@hashtag.runDate())).format("DD/MM/YYYY HH:mm")
    else
      @formatted_run_date = ''

    if(@hashtag.expirationDate())
      @formatted_expiration_date = new Date(Date.parse(@hashtag.expirationDate())).format("DD/MM/YYYY HH:mm")
    else
      @formatted_run_date = ''

  _setDaysForProgressBar: ->
    if(@hashtag.runDate())
      oneDay = 60*60*24*1000
      daysInPogress = Math.floor((Date.now() - Date.parse(@hashtag.runDate()))/oneDay) + 1
      if(daysInPogress > 7)
        daysInPogress = 0
    else
      daysInPogress = 0
    return Math.min(daysInPogress, 7)

  _setPossibleActions: (status)->
    actionView = new AccountSettings.InstagramHashtagListeningActionsView(status)
    @$el.find('#hashtag-actions').append(actionView.render().el)

  _renderRenovationType:->
    renovationTypeSelected = @hashtag.renovationType()
    renovationTypeView = new AccountSettings.InstagramHashtagListeningRenovationView(renovationTypeSelected)
    @$el.find('#renovation-type').append(renovationTypeView.render().el)

  _renderEndpoints:->
    endpointSelected = @hashtag.endpointSelected()
    endpointsView = new AccountSettings.InstagramListeningEndpointsView(endpointSelected)
    @$el.find('#listening-endpoint').append(endpointsView.render().el)

  onClickActionButton: (event)->
    event.preventDefault()
    rowActionValue = @$el.find('#action-button')[0].value
    @doUpdate(rowActionValue)

  onChangeActionSelector: (event)->
    event.preventDefault()
    rowActionValue = @$el.find('#action-selector option:selected').val()
    @doUpdate(rowActionValue)

  onChangeListeningEndpointType:(event)->
    event.preventDefault()
    selectedEndpointValue = @$el.find('#endpoint-type option:selected').val()
    @_updateListeningEndpoint(selectedEndpointValue)

  onChangeRenovationType:(event)->
    event.preventDefault()
    renovationTypeValue = @$el.find('#renovation-type-values option:selected').val()
    @_updateRenovationType(renovationTypeValue )

  doUpdate: (rowActionValue) ->
    hashtag_data = {
      source_id: @hashtag.sourceId(),
      hashtag_name: @hashtag.name(),
      hashtag_id: @hashtag.id,
      rowActionValue: rowActionValue
    }
    if(rowActionValue == @enableAction)
      swal({
        title: I18n.t('monitoring.dashboard.instagram_listening.enable_hashtag_confirmation', hashtag_name: @hashtag.name()),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        cancelButtonClass: 'btn-primary',
        confirmButtonText: I18n.t('monitoring.dashboard.instagram_listening.action.activate'),
        cancelButtonText: I18n.t('monitoring.dashboard.instagram_listening.create.cancel'),
        closeOnConfirm: true
      }, (isConfirm) =>
        if(isConfirm)
          @_enableHashtagListening(hashtag_data)
      )
    if(rowActionValue == @disableAction)
      @_disableHashtagListening(hashtag_data)
    if(rowActionValue == @removeAction)
      swal({
       title: I18n.t('monitoring.dashboard.instagram_listening.remove.confirmation',{ value:  @hashtag.name()})
       type: 'warning'
       showCancelButton: true
       confirmButtonClass: 'btn-success'
       confirmButtonText: I18n.t('monitoring.dashboard.instagram_listening.remove.remove_hashtag')
       cancelButtonText: I18n.t('monitoring.dashboard.instagram_listening.remove.dismiss')
       closeOnConfirm: true
      }, =>
        @_removeHashtagListening()
      )


  _removeHashtagListening: () ->
    @listenTo(@hashtag, 'hashtag:destroy:success', @removeFromView)
    @hashtag.remove()

  _enableHashtagListening: (hashtag_data) ->
    $.ajax
      url: '/keepcon/hashtag_searches/enable_hashtag_listening',
      type: 'POST',
      dataType: 'json',
      data: hashtag_data
      success: (response) =>
        @_handleResponse(response)

  _disableHashtagListening: (hashtag_data) ->
    $.ajax
      url: '/keepcon/hashtag_searches/disable_hashtag_listening',
      type: 'POST',
      dataType: 'json',
      data: hashtag_data
      success: (response) =>
        @_handleResponse(response)

  _updateListeningEndpoint:(listeningEndpointValue)->
    @hashtag.changeListeningEndpoint(listeningEndpointValue)

  _updateRenovationType:(renovationTypeValue)->
    @hashtag.changeRenovationType(renovationTypeValue)

  _updateToExpiredStatus:()->
    @hashtag.changeStatus('Expired')

  _handleResponse: (response) ->
    if(response.success)
      @hashtag = new AccountSettings.Hashtag(response.hashtag)
    else
      if response.keep_hashtag_dialogue
        @_showInvalidHashtagPopup(response.error_message)
      else
        showError(response.error_message)
    @render()

  _showInvalidHashtagPopup:(error_message) ->
    swal({
      title: error_message
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-success'
      confirmButtonText: I18n.t('monitoring.dashboard.instagram_listening.invalid_hashtag.keep_hashtag_on_list')
      cancelButtonText: I18n.t('monitoring.dashboard.instagram_listening.invalid_hashtag.dismiss')
      closeOnConfirm: true
    }, (isConfirm) =>
      if(isConfirm)
        #Do nothing since user wants to keep the hashtag in te list (I'm  leaving this comment for clarity)
      else
        @_removeHashtagListening()
    )

  removeFromView:->
    this.remove()
